import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useForm, Controller } from 'react-hook-form';
import { useIntl } from 'react-intl';
import Button from '@mui/material/Button';
import Select from 'components/global/AutocompleteSelect';
import { connect } from 'react-redux';
import axios from 'axios';
import FileUpload from '../global/FileUpload';
import { createResource } from '../../actions/resources';
import { API_URL } from '../../environment';
import { headers } from '../../actions/defaults';

function SendFiles({ closeModal, createResource, openSnack }) {
  const intl = useIntl();
  const { formatMessage } = intl;

  const [clients, setClients] = useState([]);
  const [fetchComplete, setFetchComplete] = useState(false);

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      client: null,
      file: [],
    },
  });

  // Fetch clients on mount
  useEffect(() => {
    axios
      .get(`${API_URL}/practice/clients/client_selector`, headers())
      .then(res => {
        const options = res.data
          .map(client => ({
            value: client.id,
            label: client.full_name.replace('  ', ' '),
          }))
          .sort((a, b) => a.label.localeCompare(b.label));

        setClients(options);
        setFetchComplete(true);
      })
      .catch(() => {
        setClients([]);
        setFetchComplete(true);
      });
  }, []);

  const onSubmit = values => {
    const body = new FormData();
    body.append('file', values.file[0]);
    body.append('client', values.client?.value);

    createResource(body, () => {
      closeModal();
      openSnack(
        formatMessage({ defaultMessage: 'Successfully uploaded file.' }),
      );
      reset();
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {/* Client Selector */}
      <div style={{ marginBottom: '1em', width: '300px' }}>
        <label className="shelf-form-title">
          {formatMessage({ defaultMessage: 'Client' })}
        </label>
        <Controller
          name="client"
          control={control}
          rules={{
            required: formatMessage({
              defaultMessage: 'Please choose a client.',
            }),
          }}
          render={({ field }) => (
            <Select
              {...field}
              options={clients}
              isClearable
              isSearchable
              placeholder={formatMessage({ defaultMessage: 'Search...' })}
              value={clients.find(c => c.value === field.value?.value) || null}
              onChange={val => field.onChange(val)}
            />
          )}
        />
        {errors.client && (
          <span className="error-text">{errors.client.message}</span>
        )}
      </div>

      {/* File Upload */}
      <div style={{ marginBottom: '1em' }}>
        <h6 className="shelf-form-title">
          {formatMessage({ defaultMessage: 'File' })}
        </h6>
        <Controller
          name="file"
          control={control}
          rules={{
            validate: value =>
              value && value.length > 0
                ? true
                : formatMessage({ defaultMessage: 'Choose File' }),
          }}
          render={({ field }) => (
            <FileUpload
              {...field}
              error={errors.file?.message}
            />
          )}
        />
      </div>

      {/* Submit */}
      <Button
        className="big-flat-button-green"
        type="submit"
      >{formatMessage({ defaultMessage: 'SEND FILES' })}</Button>
    </form>
  );
}

SendFiles.propTypes = {
  closeModal: PropTypes.func.isRequired,
  createResource: PropTypes.func.isRequired,
  openSnack: PropTypes.func.isRequired,
};

export default connect(null, { createResource })(SendFiles);
